/**
 * @fileoverview POST handler for the "/data_objects/user_relationship_types/:rel_type_id/fields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsUserRelationshipTypeFieldsCacheKeys } from "./constants";
import type {
  PostCustomObjectsUserRelationshipTypeFieldsProps,
  PostCustomObjectsUserRelationshipTypeFieldsResult,
} from "./types";

export const postCustomObjectsUserRelationshipTypeFields = reactQueryMutationAdapter(
  customObjectsUserRelationshipTypeFieldsCacheKeys,
  ({
    appGroupId,
    relTypeId,
    name,
    data_type,
    display_label,
    required,
  }: PostCustomObjectsUserRelationshipTypeFieldsProps): Promise<PostCustomObjectsUserRelationshipTypeFieldsResult> => {
    return fetch<PostCustomObjectsUserRelationshipTypeFieldsResult>(
      `/data_objects/user_relationship_types/${encodeURIComponent(relTypeId)}/fields`,
      "POST",
      {
        app_group_id: appGroupId,
        name,
        data_type,
        display_label,
        required,
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
